// extracted by mini-css-extract-plugin
export default {"participation":"styles_participation__L55rF","row":"styles_row__V5nFf","toggle":"styles_toggle__wmxUE"};